import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Player} from '../../../../domain/player';

@Component({
  selector: 'sg-player-profile',
  templateUrl: './player-profile.component.html',
  styleUrls: ['./player-profile.component.scss']
})
export class PlayerProfileComponent {
  @Input() player: Player;
  @Output() playerChange = new EventEmitter<Player>();
  @Output() cancelled = new EventEmitter();
  @Output() deletePlayer = new EventEmitter<Player>();
  @Input() existingPlayer: boolean;
  @Input() avatarID: number;

  showChooseAvatar = false;
  selectedFrame: number;
  frameSubscript = ['DOODSBANG, VERPEST MIJN LEVEN', 'DOOD NEE! WEG ERMEE!', 'VIND T MAAR NIKS',  'THIS IS NOT HAPPENING', 'HOORT ERBIJ, IS NIET ANDERS', 'GEEN ENKEL PROBLEEM', 'SUPER DAT DE DOOD BESTAAT!'];
  showPpDialog = false;

  gekozenAvatar($event) {
    if ($event != null) {
      this.player.avatarIcon = $event.avatarID;
    } else {
      this.showChooseAvatar = false;
    }
  }

  gekozenFrame(i) {
    this.player.anxChoice = i;
    this.selectedFrame = i;
  }

  dialogKeuzeFunc($event) {
    if ($event != null) {
      this.deletePlayer.emit(this.player);
      this.showPpDialog = false;
    } else {
      this.showPpDialog = false;
    }
  }
}
